import React, { useEffect, useState } from 'react';
import CmsPage from './CmsPage';
import { applySeo } from '../utils/seoManager';
import './LandingPageView.css';

const LandingPageView = ({ slug }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/landing-pages/slug/${slug}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        setPage(data);
        if (data) {
          applySeo({
            seoTitle: data.seoTitle || data.title,
            metaDescription: data.metaDescription,
            canonicalUrl: data.canonicalUrl,
            ogTitle: data.ogTitle,
            ogDescription: data.ogDescription,
            ogImage: data.ogImage,
          });
        }
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="landing-loading">Loading...</div>;
  if (!page) return <div className="landing-not-found">Landing page not found.</div>;

  return (
    <div className={`landing-page-view ${page.hideHeaderFooter ? 'landing-standalone' : ''}`}>
      <CmsPage page={page} />
    </div>
  );
};

export default LandingPageView;
